<template>
    <b-upload v-model="img"
        @input="upload()"
        accept="image/*"
        drag-drop>
        <section class="section">
            <div class="content has-text-centered">
                <p>
                    <b-icon
                        icon="upload"
                        size="is-large">
                    </b-icon>
                </p>
                <span class="file-name" v-if="img" >
                    {{ img.name }}
                </span>
                <v-img
                    v-if="!!img_url"
                    v-bind:src="img_url"
                    width="180px"
                    alt="Placeholder image"    
                >
                </v-img>
                <span v-else>
                    <p>Загрузить Изображение</p>
                </span>
            </div>
        </section>
    </b-upload>
</template>

<script>
import { AxiosClient } from '@/app/shared/services';
export default {
    name: 'FileUpload',
    props: [
        'model',
    ],
    data() {
        return {
            img: null
        };
    },
    created(){

    },  
    computed:{
        img_url: {
            get() {
                return this.model;
            },
            set(value) {
                this.$emit('update:model', value);
            }
        },
    },
    methods: {
        upload() {
            const formData = new FormData();
            formData.append('img', this.img);
            AxiosClient.post(`/notification/upload_img`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then((data) => {
                    this.$toaster.success('Изображение загружено');
                    this.img_url = data.data.url;
                })
                .catch((error) => {
                    this.$toaster.error('Ошибка при загрузке изображения!');
                    console.log(error)
                });
        }
    }
}
</script>

<style>

</style>